import React from 'react';

const LoadingDots = () => (
  <span className="dots">
    <span className="dots-bounce dots-bounce--1"/>
    <span className="dots-bounce dots-bounce--2"/>
    <span className="dots-bounce dots-bounce--3"/>
  </span>
);

LoadingDots.displayName = 'LoadingDots';

export default LoadingDots;
